import ConnectedDownloadCodesContainer from './containers/createCampaign/DownloadCodesContainer';
import PaymentWalletGate from './containers/createCampaign/PaymentWalletGate';
import ConnectedConfigurationContainer from './containers/createCampaign/ConfigurationContainer';

const createCampaignStepDefinitions = [
  {
    id: 'configuration',
    name: 'Configure',
    dependencyIds: [],
    component: ConnectedConfigurationContainer,
  },
  {
    id: 'payment',
    name: 'Payment',
    dependencyIds: ['configuration'],
    component: PaymentWalletGate,
  },
  {
    id: 'downloadCodes',
    name: 'Distribute Codes',
    dependencyIds: ['payment'],
    component: ConnectedDownloadCodesContainer,
  },
];

export default createCampaignStepDefinitions;



// WEBPACK FOOTER //
// ./src/createCampaignStepDefinitions.js